// GENERATED FILE - do not edit by hand.
// Written by scripts/changelog/build.mjs from git history and docs/changelog/.
// Run "pnpm changelog:build" after committing to refresh it.

/** Current product version, derived from Conventional Commits (AGENTS.md §5). */
export const APP_VERSION = "0.1369.16";

/** How many changelog entries exist behind that version. */
export const CHANGELOG_ENTRIES = 4574;

/** When the two values above were last derived. */
export const VERSION_GENERATED_AT = "2026-11-03T20:08:21.196Z";
